// extracted by mini-css-extract-plugin
export default {"input":"clockinput_input__MHCn3","wrapper":"clockinput_wrapper__qShJq","hiddenInput":"clockinput_hiddenInput__W9UKa"};